import apiFetch from '../apiFetch'

export default function (checkListId, token) {
  return apiFetch({ endPoint: `CheckList/${checkListId}/Sign`, token: token, method: 'PUT' })
}
